import React from 'react';
import { Navigate } from 'react-router-dom';
import { cookie } from 'utils/cookies';

const withAuth = (BaseComponent) => {
  return function EnhancedComponent(props) {
    const isAuthenticated = cookie.get('token');
    const userRole = cookie.get('user-role');

    if (isAuthenticated) {
      if (userRole === 'contractor') {
        return <Navigate to="/contractorView" />;
      }
      if (userRole === 'quality') {
        return <Navigate to="/formList" />;
      }
      return <Navigate to="/dashboard" />;
    }

    // HOC-specific logic using hooks
    return <BaseComponent {...props} />;
  };
};

export default withAuth;
